<template>
  <div class="user-role">
    <div
      class="user-role__icon"
      :style="{
        backgroundColor: $options.ROLE_ICON_COLORS[role],
      }"
    >
      <svg
        width="12"
        height="11"
        viewBox="0 0 12 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.04262 9.45357C3.5535 9.45357 1.52849 7.41613 1.52849 4.91155C1.52849 2.40681 3.5535 0.369072 6.04262 0.369072C8.53251 0.369072 10.5581 2.40666 10.5581 4.91155C10.5581 7.41613 8.53251 9.45357 6.04262 9.45357ZM6.04262 1.13088C3.97351 1.13088 2.29014 2.82682 2.29014 4.91155C2.29014 6.99598 3.97335 8.69177 6.04262 8.69177C8.1125 8.69177 9.79647 6.99598 9.79647 4.91155C9.79647 2.82697 8.1125 1.13088 6.04262 1.13088Z"
          fill="white"
        />
        <path
          d="M11.3835 10.6845C11.5939 10.6845 11.7644 10.514 11.7644 10.3036V10.3359C11.7644 8.96006 11.0025 7.91754 9.5606 7.32095C9.36629 7.24047 9.14363 7.33293 9.06315 7.52709C8.98282 7.72141 9.07512 7.94422 9.26943 8.02455C10.4358 8.50731 11.0028 9.2632 11.0028 10.3357V10.3036C11.0026 10.514 11.1731 10.6845 11.3835 10.6845Z"
          fill="white"
        />
        <path
          d="M11.3838 10.6845C11.5942 10.6845 11.7647 10.514 11.7647 10.3036V10.3359C11.7647 8.96006 11.0027 7.91754 9.56081 7.32095C9.3665 7.24047 9.14384 7.33293 9.06335 7.52709C8.98302 7.72141 9.07533 7.94422 9.26964 8.02455C10.436 8.50731 11.003 9.2632 11.003 10.3357V10.3036C11.0029 10.514 11.1734 10.6845 11.3838 10.6845Z"
          fill="white"
        />
        <path
          d="M0.587399 10.6845C0.377016 10.6845 0.206497 10.514 0.206497 10.3036V10.3359C0.206497 8.96006 0.968453 7.91754 2.41036 7.32095C2.60468 7.24047 2.82734 7.33293 2.90782 7.52709C2.98816 7.72141 2.89585 7.94422 2.70153 8.02455C1.53518 8.50731 0.968149 9.2632 0.968149 10.3357V10.3036C0.968301 10.514 0.797782 10.6845 0.587399 10.6845Z"
          fill="white"
        />
        <path
          d="M4.873 4.82309H4.35856C4.14803 4.82309 3.97751 4.65257 3.97751 4.44204C3.97751 4.23181 4.14803 4.06129 4.35856 4.06129H4.873C5.08338 4.06129 5.2539 4.23181 5.2539 4.44204C5.2539 4.65257 5.08338 4.82309 4.873 4.82309Z"
          fill="white"
        />
        <path
          d="M7.79353 4.82309H7.27894C7.06856 4.82309 6.89804 4.65257 6.89804 4.44204C6.89804 4.23181 7.06856 4.06129 7.27894 4.06129H7.79353C8.00391 4.06129 8.17443 4.23181 8.17443 4.44204C8.17443 4.65257 8.00391 4.82309 7.79353 4.82309Z"
          fill="white"
        />
        <path
          d="M6.98526 5.89224C6.65685 6.54906 6.00004 6.54906 6.00004 6.54906C6.00004 6.54906 5.34322 6.54906 5.01482 5.89224"
          stroke="white"
          stroke-linecap="round"
        />
      </svg>
    </div>
    <div class="user-role__name">
      {{ $t(`roles.${role}`) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserRole',
  props: {
    role: {
      type: String,
    },
  },

  data() {
    return {}
  },

  ROLE_ICON_COLORS: {
    manager: '#C8B5FF',
    administrator: '#64748B',
  },
}
</script>

<style lang="scss" scoped>
.user-role {
  display: flex;
  align-items: center;
  &__icon {
    width: 16px;
    height: 16px;
    border-radius: 5px;
    background: #eeeeee;
    margin-right: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__name {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: #67768a;
  }
}
</style>
